import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

export const POST_SALE_PAGES = Object.freeze({
  COLLECTION: 'Collection Page',
  SALE_DETAILS: 'Sale details page',
});

export const POST_SALE_SNOW_PLOW_EVENTS = Object.freeze({

  CHECKLIST_COLLECTION_DAY_LINK_CLICKED: ({ salePage = false, url = '' }: { salePage?: boolean; url?: string }) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: salePage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    name: 'checklist_collection_day_link_clicked',
    url,
  }),

  CHECKLIST_NEGATIVE_EQUITY_LINK_CLICKED: ({ salePage = false, url = '' }: { salePage?: boolean; url?: string }) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: salePage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    name: 'checklist_negative_equity_link_clicked',
    url,
  }),

  CHECKLIST_PREPARE_HANDOVER_LINK_CLICKED: ({ salePage = false, url = '' }: { salePage?: boolean; url?: string }) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: salePage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    name: 'checklist_prepare_handover_link_clicked',
    url,
  }),

  CHECKLIST_VEHICLE_DETAILS_LINK_CLICKED: ({ salePage = false, url = '' }: { salePage?: boolean; url?: string }) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: salePage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    name: 'checklist_vehicle_details_link_clicked',
    url,
  }),

  COLLECTION_CONFIRMED: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Confirm sale',
    category: POST_SALE_PAGES.COLLECTION,
    name: 'collection_confirmed',
    success: true,
    url: 'N/A',
  }),

  COLLECTION_CONFIRMED_UNDO: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.COLLECTION,
    name: 'collection_confirmed_undo',
  }),

  COLLECTION_PREFERENCES_DATE_CLICKED: (selected: boolean, label: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.COLLECTION,
    label,
    name: selected ? 'Date chip selected' : 'Date chip deselected',
  }),

  COLLECTION_PREFERENCES_DATES_SUBMITTED: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Submit request',
    category: POST_SALE_PAGES.COLLECTION,
    name: 'collection_preferences_dates_submitted',
    success: true,
    url: 'N/A',
  }),

  COLLECTION_PREFERENCES_DATES_UNAVAILABLE: (dates: string) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Submit request',
    category: POST_SALE_PAGES.COLLECTION,
    label: dates,
    name: 'collection_preferences_dates_unavailable',
    success: false,
    url: 'N/A',
  }),

  COLLECTION_PREFERENCES_MODAL_CLOSED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.COLLECTION,
    name: 'collection_preferences_modal_closed',
  }),

  COLLECTION_PREFERENCES_MODAL_OPENED: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Select now',
    category: POST_SALE_PAGES.COLLECTION,
    name: 'collection_preferences_modal_opened',
    success: true,
    url: 'N/A',
  }),

  COLLECTION_STATUS_LOADED: (label?: string) => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: POST_SALE_PAGES.COLLECTION,
    label,
    name: 'collection_status',
  }),

  DEALER_DETAILS_MODAL_CLOSED: (
    { dealer, isSaleDetailsPage = false }: { dealer: string; isSaleDetailsPage?: boolean },
  ) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: isSaleDetailsPage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    label: dealer,
    name: 'dealer_details_modal_closed',
  }),

  DEALER_DETAILS_MODAL_EMAIL_CLICKED: (isSaleDetailsPage?: boolean) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: isSaleDetailsPage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    name: 'dealer_details_modal_email_clicked',
  }),

  DEALER_DETAILS_MODAL_OPENED: (dealer: string) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: `${dealer} View details`,
    category: POST_SALE_PAGES.COLLECTION,
    label: dealer,
    name: 'dealer_details_modal_opened',
    success: true,
    url: 'N/A',
  }),

  DEALER_DETAILS_MODAL_PHONE_NUMBER_CLICKED: (
    isSaleDetailsPage: boolean = false,
  ) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: isSaleDetailsPage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    name: 'dealer_details_modal_phone_number_clicked',
  }),

  HELP_MODAL_HEADER_OPENED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.COLLECTION,
    name: 'help_modal_header_opened',
  }),

  HELP_MODAL_SALE_DETAILS_OPENED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.COLLECTION,
    name: 'help_modal_sale_details_opened',
  }),

  LEARN_MORE_NEGATIVE_EQUITY: (isSaleDetailsPage?: boolean) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: isSaleDetailsPage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    name: 'learn_more_negative_equity',
  }),

  NEED_HELP_SALE_COLLECTION_CTA_CLICK: ({ isSaleDetailsPage = false, url = 'N/A' }: { isSaleDetailsPage?: boolean; url?: string }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Need sale or collection help? Always contact Motorway first',
    category: isSaleDetailsPage ? POST_SALE_PAGES.SALE_DETAILS : POST_SALE_PAGES.COLLECTION,
    name: 'need_help_sale_collection_cta_click',
    url,
  }),

  PREPARE_FOR_COLLECTION_CLICKED: (url: string) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'N/A', // Update!
    category: POST_SALE_PAGES.COLLECTION,
    name: 'prepare_for_collection_cta_click',
    url,
  }),

  SALE_SUPPORT_MODAL_EMAIL_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.SALE_DETAILS,
    name: 'sale_support_modal_email_clicked',
  }),

  SALE_SUPPORT_MODAL_PHONE_NUMBER_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.SALE_DETAILS,
    name: 'sale_support_modal_phone_number_clicked',
  }),

  VIEW_DEALERS_DETAILS_MODAL_OPENED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.SALE_DETAILS,
    name: 'view_dealer_details_modal_opened',
  }),

  VIEW_SALE_DETAILS_MODAL_CLOSED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.SALE_DETAILS,
    name: 'view_sale_details_modal_closed',
  }),

  VIEW_VEHICLE_PROFILE: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: POST_SALE_PAGES.COLLECTION,
    name: 'view_vehicle_profile',
  }),
});
